import { render, staticRenderFns } from "./ProjectProductPackages.vue?vue&type=template&id=4f0f17c8&scoped=true"
import script from "./ProjectProductPackages.vue?vue&type=script&lang=ts"
export * from "./ProjectProductPackages.vue?vue&type=script&lang=ts"
import style0 from "./ProjectProductPackages.vue?vue&type=style&index=0&id=4f0f17c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f17c8",
  null
  
)

export default component.exports